import { render } from "./HeaderTab.vue?vue&type=template&id=14221510"
import script from "./HeaderTab.vue?vue&type=script&lang=js"
export * from "./HeaderTab.vue?vue&type=script&lang=js"

import "./HeaderTab.vue?vue&type=style&index=0&id=14221510&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__